import {
  Menu as SemanticMenu,
  MenuItem as SemanticMenuItem,
} from "semantic-ui-react";

export const Menu = SemanticMenu;
Menu.Item = SemanticMenu.Item;
export { SemanticMenuItem as MenuItem };
